var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpdesk"},[_c('a',{attrs:{"href":"https://bit.ly/4dOYcng","target":"_blank"},on:{"click":_vm.trackClick}},[_c('i',{staticClass:"material-icons"},[_vm._v("help")]),_vm._v(" Central de Ajuda\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }